import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-900 text-slate-300 pt-20 pb-10 border-t border-white/10" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4" data-id="element-36">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-37">
          {/* Company Info */}
          <div className="space-y-6" data-id="element-38">
            <Link to="/" className="flex items-center gap-2" data-id="element-39">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-tech-blue to-tech-green flex items-center justify-center text-white font-bold text-xl" data-id="element-40">
                IT
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-41">
                Invigo<span className="text-tech-green" data-id="element-42">Tech</span>
              </span>
            </Link>
            <p className="text-sm leading-relaxed" data-id="element-43">
              Powering digital transformation across Africa. We deliver premium
              ICT infrastructure, systems integration, and managed services for
              enterprises and governments.
            </p>
            <div className="flex gap-4" data-id="element-44">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-tech-blue hover:text-white transition-colors" data-id="element-45">
                <Linkedin className="w-5 h-5" data-id="element-46" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-tech-blue hover:text-white transition-colors" data-id="element-47">
                <Twitter className="w-5 h-5" data-id="element-48" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-tech-blue hover:text-white transition-colors" data-id="element-49">
                <Facebook className="w-5 h-5" data-id="element-50" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-tech-blue hover:text-white transition-colors" data-id="element-51">
                <Instagram className="w-5 h-5" data-id="element-52" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-53">
            <h3 className="text-white font-semibold text-lg mb-6" data-id="element-54">
              Quick Links
            </h3>
            <ul className="space-y-4" data-id="element-55">
              <li data-id="element-56">
                <Link to="/about" className="hover:text-tech-green transition-colors" data-id="element-57">
                  About Us
                </Link>
              </li>
              <li data-id="element-58">
                <Link to="/services" className="hover:text-tech-green transition-colors" data-id="element-59">
                  Our Services
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/projects" className="hover:text-tech-green transition-colors" data-id="element-61">
                  Case Studies
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/industries" className="hover:text-tech-green transition-colors" data-id="element-63">
                  Industries
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/insights" className="hover:text-tech-green transition-colors" data-id="element-65">
                  Insights & News
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-66">
            <h3 className="text-white font-semibold text-lg mb-6" data-id="element-67">
              Our Services
            </h3>
            <ul className="space-y-4" data-id="element-68">
              <li data-id="element-69">
                <Link to="/services" className="hover:text-tech-green transition-colors" data-id="element-70">
                  ICT Infrastructure
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/services" className="hover:text-tech-green transition-colors" data-id="element-72">
                  Systems Integration
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/services" className="hover:text-tech-green transition-colors" data-id="element-74">
                  Managed IT Services
                </Link>
              </li>
              <li data-id="element-75">
                <Link to="/services" className="hover:text-tech-green transition-colors" data-id="element-76">
                  Business Process Mgmt
                </Link>
              </li>
              <li data-id="element-77">
                <Link to="/services" className="hover:text-tech-green transition-colors" data-id="element-78">
                  Digital Inclusion
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-79">
            <h3 className="text-white font-semibold text-lg mb-6" data-id="element-80">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-81">
              <li className="flex items-start gap-3" data-id="element-82">
                <MapPin className="w-5 h-5 text-tech-green shrink-0 mt-1" data-id="element-83" />
                <span data-id="element-84">Audu Ogbeh Street, Jabi, Abuja, Nigeria</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-85">
                <Phone className="w-5 h-5 text-tech-green shrink-0" data-id="element-86" />
                <span data-id="element-87">0700-INVIGO</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-88">
                <Mail className="w-5 h-5 text-tech-green shrink-0" data-id="element-89" />
                <span data-id="element-90">info@invigoco.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm" data-id="element-91">
          <div className="flex flex-col md:flex-row items-center gap-4" data-id="element-92">
            <p data-id="element-93">&copy; {currentYear} Invigo Technology. All rights reserved.</p>
            <span className="hidden md:inline text-white/20" data-id="element-94">|</span>
            <a href="https://www.invigoco.com" target="_blank" rel="noopener noreferrer" className="hover:text-tech-green transition-colors font-medium" data-id="element-95">
              www.invigoco.com
            </a>
          </div>
          <div className="flex gap-6" data-id="element-96">
            <Link to="#" className="hover:text-white transition-colors" data-id="element-97">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-white transition-colors" data-id="element-98">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}